import { render, staticRenderFns } from "./FacebookIdentity.vue?vue&type=template&id=f9e3f2bc&scoped=true"
import script from "./FacebookIdentity.vue?vue&type=script&lang=js"
export * from "./FacebookIdentity.vue?vue&type=script&lang=js"
import style0 from "./FacebookIdentity.vue?vue&type=style&index=0&id=f9e3f2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e3f2bc",
  null
  
)

export default component.exports